import { UserRole } from 'types/shared-types';

export const USER_ROLES = [
  { label: UserRole.Owner, value: UserRole.Owner },
  { label: UserRole.Admin, value: UserRole.Admin },
  { label: UserRole.Member, value: UserRole.Member },
];
